import { ProductCardModel } from "src/business/openapi";


export function setJsonldFromResults(results: ProductCardModel[], uuid: string, name: string): void {
  document.head.getElementsByClassName(uuid)?.item(0)?.remove();
  const s = document.createElement('script');
  s.setAttribute('type', "application/ld+json");
  s.setAttribute('class', uuid);
  s.innerHTML = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    "itemListElement": results.map((r, i) => ({
      "@type": "ListItem",
      "position": i,
      "url": r.url
    }))
  });
  document.head.append(s);
}

export function clearJsonld(uuid: string) {
  document.head.getElementsByClassName(uuid)?.item(0)?.remove();
}
